import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const ExclamationInCircleIconFilled: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M12 13V8" stroke="#F3F3F3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M12 15.5C12.2761 15.5 12.5 15.7239 12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5Z" fill="currentColor" stroke="#F3F3F3" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ExclamationInCircleIconFilled;